export default __webpack_public_path__ + "static/media/news-1.430d3278.jpg";